import xHttp from '@utils/xHttp';
import { getBaseAwsApiUrl, getLanditApiVersion } from '@utils/config';

export const searchLand = (listingSearch) => {
  let url = `${getBaseAwsApiUrl()}${getLanditApiVersion()}/property_listings/search`;

  return xHttp.post(url, listingSearch);
};

export const getLandById = (listingKey) => {
  let url = `${getBaseAwsApiUrl()}${getLanditApiVersion()}/property_listings/${listingKey}`;
  return xHttp.get(url);
};
